import request from '@/utils/request'

export default {
  turnoverTrend: (params) => request({ url: '/postInvest/turnoverTrend', method: 'post', data: params }),
  recoveryTable: (params) => request({ url: '/postInvest/recoveryTable', method: 'post', data: params }),
  createTodo: (params) => request({ url: '/postInvest/createTodo', method: 'post', data: params }),
  getTodoList: (params) => request({ url: '/postInvest/getTodoList', method: 'post', data: params }),
  updateTodoStatus: (params) => request({ url: '/postInvest/updateTodoStatus', method: 'post', data: params }),
  getBankTransLogs: (params) => request({ url: '/postInvest/getBankTransLogs', method: 'post', data: params }),
  writeOffBankTransLog: (params) => request({ url: '/postInvest/writeOffBankTransLog', method: 'post', data: params }),
  getPendingAmount: (params) => request({ url: '/postInvest/getPendingAmount', method: 'post', data: params }),
  refreshIncomeData: (params) => request({ url: '/postInvest/refreshIncomeData', method: 'post', data: params }),
  confirmDataFix: (params) => request({ url: '/postInvest/confirmDataFix', method: 'post', data: params }),
  ignoreBankTransLog: (params) => request({ url: '/postInvest/ignoreBankTransLog', method: 'post', data: params }),
}